import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import ScrollToTop from "./Components/ScrollToTop";


import Home from "./Components/Home";
import Menu from "./Components/Menu";
import VisitUs from "./Components/VisitUs";
import Loader from "./Components/Loader";
import "./Style/Responsive.css";


function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/visit" element={<VisitUs />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <Router>
       <ScrollToTop />   {/* ✅ always scroll to top on route change */}
    <AnimatedRoutes />
    </Router>
  );
}

export default App;










